// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget';
import seoWidget from './js/widgets/seoWidget';
import activitiesWidget from './js/widgets/activitiesWidget';
import * as socialFeedWidget from './js/widgets/socialFeedWidget';
import hotButtonsWidget from './js/widgets/hotButtonsWidget';
import sponsorsList from './js/widgets/sponsorsList';
import timeEvent from './js/widgets/timeEvent';
// Custom Theme Scripts
import './js/localjs';

let executedForViewport = {
  small: false,
  medium: false,
  large: false,
};

function executeActivitiesWidget() {
  const windowWidth = window.innerWidth;

  if (windowWidth < 804 && executedForViewport.small === false) {
    $('#activitiesWidget').empty();
    activitiesWidget();
    executedForViewport = { small: true, medium: false, large: false };
  } else if (
    windowWidth >= 805 &&
    windowWidth <= 1300 &&
    executedForViewport.medium === false
  ) {
    $('#activitiesWidget').empty();
    activitiesWidget();
    executedForViewport = { small: false, medium: true, large: false };
  } else if (windowWidth > 1300 && executedForViewport.large === false) {
    $('#activitiesWidget').empty();
    activitiesWidget();
    executedForViewport = { small: false, medium: false, large: true };
  }
}

// Initialize Homepage Widgets

if (window.location.pathname === '/') {
  $(document).ready(() => {
    swiperWidget();
    seoWidget();
    executeActivitiesWidget();
    hotButtonsWidget();
    sponsorsList();
  });
  $(window).load(() => {
    socialFeedWidget.facebookfeed(true);
  });
  $(window).resize(() => {
    executeActivitiesWidget();
  });
}
$(window).load(() => {
  timeEvent();
});
